import { render } from "./ActiveCustomer.vue?vue&type=template&id=dd2faba0&scoped=true"
import script from "./ActiveCustomer.vue?vue&type=script&lang=js"
export * from "./ActiveCustomer.vue?vue&type=script&lang=js"

import "./ActiveCustomer.vue?vue&type=style&index=0&id=dd2faba0&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022759/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd2faba0"]])

export default __exports__